import find from 'lodash/find'
import map from 'lodash/map'
import React from 'react'
import { gql } from '@apollo/client'
import { Select } from '@ztechapps/webui.input'
import { useList } from '@ztechapps/common.hook'

const query = gql(`
  query timezone_getAllAsString {
    timezone_getAllAsString
  }
`)

/**
 * This will get all timezone and display here
 * @returns {JSX.Element}
 * @constructor
 */
export const WorldTimeZoneSelect = ({ value, ...rest }: any) => {
  const { list, loading } = useList({ query, entity: 'timezone_getAllAsString', filter: {}, limit: 0 })

  const options = React.useMemo(() => {
    return map(list, (e) => ({ value: e, label: e }))
  }, [list])

  const objValue = React.useMemo(() => find(options, { value }), [value, options])

  return (
    <Select
      {...{
        ...rest,
        value: objValue,
        options,
        isLoading: loading,
        placeholder: 'Type timezone name here.',
        noOptionsMessage: () => 'No available time zone name.',
      }}
    />
  )
}
